import '@content/foundations/src/index'
import asWebComponent from '../../asWebComponent'
import EnhancedPopIn from './EnhancedPopInWrapper'

export default asWebComponent(EnhancedPopIn, 'nb-enhanced-pop-in', ['data'])
